import './style.css';
import { Game } from './Game.js';

// Reveal body once CSS is loaded (prevents flash of unstyled HTML)
document.body.classList.add('ready');

const LAUNCH_CODE = 'jimmy';
const LAUNCH_KEY = 'meghas-universe:launched';

// Load the real HYG star catalog (filtered to mag ≤ 6, ~5000 stars).
// Built once via `node tools/build-hyg.js`.
const hygResponse = await fetch('/data/hyg.json');
if (!hygResponse.ok) {
  throw new Error(`Failed to load star catalog: ${hygResponse.status}`);
}
const hyg = await hygResponse.json();
console.log(`Loaded ${hyg.length} stars from HYG catalog`);

/**
 * Launch gate - if the visitor has already entered the code (stored in
 * localStorage), skip straight to the game. Otherwise, show the launch
 * code overlay and wait for the correct input. On success, show a brief
 * "Launch authorized" status, then fade into the opening sequence.
 */
function initGate() {
  const overlay = document.getElementById('launch-overlay');
  const input = document.getElementById('launch-input');
  const dots = document.getElementById('launch-dots');
  const error = document.getElementById('launch-error');
  const status = document.getElementById('launch-status');

  if (!overlay || localStorage.getItem(LAUNCH_KEY) === 'true') {
    if (overlay) overlay.style.display = 'none';
    startGame();
    return;
  }

  // Render masked dots as the user types
  input.addEventListener('input', () => {
    const len = input.value.length;
    dots.innerHTML = Array.from({ length: len }, () =>
      '<span>*</span>'
    ).join('');
  });

  input.addEventListener('keydown', (e) => {
    if (e.key === 'Enter') {
      const value = input.value.trim().toLowerCase();
      if (value === LAUNCH_CODE) {
        localStorage.setItem(LAUNCH_KEY, 'true');
        input.disabled = true;

        // Show "Launch authorized" status
        error.textContent = '';
        status.textContent = 'Launch authorized';
        status.classList.add('visible');

        // Brief hold so she reads the status, then fade out
        setTimeout(() => {
          overlay.classList.add('dismissed');
          // Start the game behind the fading overlay so the opening
          // sequence begins as the gate dissolves
          startGame();
          setTimeout(() => overlay.remove(), 2200);
        }, 1200);
      } else {
        input.classList.remove('shake');
        void input.offsetHeight;
        input.classList.add('shake');
        error.textContent = 'Incorrect launch code';
        setTimeout(() => {
          error.textContent = '';
          input.classList.remove('shake');
        }, 2000);
      }
    }
  });
}

function startGame() {
  const game = new Game({ hyg });
  game.start();

  if (import.meta.env.DEV) {
    window.game = game;
    window.hyg = hyg;
  }
}

initGate();
